import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const CheckboxCheckedIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="0.75"
        y="0.75"
        width="14.5"
        height="14.5"
        rx="3.25"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <rect x="3.5" y="3.5" width="9" height="9" rx="2" fill="currentColor" />
    </BaseIcon>
  );
};

export const CheckboxUncheckedIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="0.75"
        y="0.75"
        width="14.5"
        height="14.5"
        rx="3.25"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </BaseIcon>
  );
};

export const CheckboxIndeterminateIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="0.75"
        y="0.75"
        width="14.5"
        height="14.5"
        rx="3.25"
        fill="currentColor"
      />
      <rect
        x="0.75"
        y="0.75"
        width="14.5"
        height="14.5"
        rx="3.25"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M12 8L4 8"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </BaseIcon>
  );
};

CheckboxCheckedIcon.displayName = 'CheckboxCheckedIcon';
CheckboxUncheckedIcon.displayName = 'CheckboxUncheckedIcon';
CheckboxIndeterminateIcon.displayName = 'CheckboxIndeterminateIcon';
